import undo from '@/mixins/Customizer/Undo';

export default {
  mixins: [undo],
  data() {
    return {
      componentName: 'personalizationMainView',
      ctaButtons: {
        personalizationMainView: "personalizeNext",
        personalizationConfirmView: "embroideryApplyBtn",
      },
      disableButtons: false,
    }
  },
  computed:{
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    translations() {
      return this.$store.state.translations.data;
    },
  },
  methods: {
    setComponentName(componentName) {
      this.componentName = componentName;
    },
    setDisableButtons(value) {
      this.disableButtons = value;
    },

    /**
     * @function applyComponentPersonalization
     * @param {String} componentName - Component to which personalization will be applied
     * Applies Swatch personalization
     *
     */
    applyComponentPersonalization(componentName) {
      const componentsToRemove = this.$store.state.utils.pdm.components.personalization
        .personalization_remove_components;

      if (componentsToRemove && componentsToRemove.length > 0) {
        const parentComponent = this.recipe_v2.components[componentName];

        this.$store.commit('swatches/SET_SWATCHES_SELECTED', {
          component: componentName,
          data: {
            swatchId: parentComponent.swatch_id.toString(),
            group: parentComponent.group,
            subgroup: parentComponent.subgroup,
          }
        });
      }
    },

    /**
     * Apply Personalization from Swatch
     * @param personalization
     */
    applyPersonalizationFromSwatch (personalization) {
      if (!personalization) {
        return;
      }

      let lMessage = '';
      let rMessage = '';
      for (let i in personalization) {
        const location = personalization[i].location.toLowerCase();
        if (location === 'left shoe') {
          lMessage = personalization[i].text;
        } else if (location === 'right shoe') {
          rMessage = personalization[i].text;
        }
      }
      if (lMessage === '' && rMessage === '') {
        return;
      }

      this.$store.commit('personalization/SAVE_USER_DATA');
      this.$store.commit(
        'personalization/SAVE_DATA',
        { text: lMessage.toUpperCase(), index: 0 },
      );
      this.$store.commit(
        'personalization/SAVE_DATA',
        { text: rMessage.toUpperCase(), index: 1 },
      );
      this.$store.commit(
        'personalization/CHANGE_COLOR',
        this.getColorByName(personalization[0].color),
      );

      const componentName = this.$store.getters["personalization/getPersonalizationComponentName"];

      this.$store.commit('personalization/ADD_PERSONALIZATION_COMPONENT', componentName);
      this.$personalization.applyTextToCanvas({ personalizationComponent: componentName });
    },

    /**
     * @function closeModal
     * @description Closes the Personalization modal (this one).
     * This method is used by the Close button and the Apply button that completes the Personalization (Embroidery) activity.
     * @returns undefined
    */
    closeModal(isClosed = true) {
      if (!isClosed) return;
      this.$embroideryDataLayer.logAnalyticsEvent({
        eventLabel: this.$embroideryDataLayer.labels.closeModal,
      });

      this.$store.commit('personalization/RESET_STEP');
      this.$store.commit('personalization/DELETE_DATA');
      this.$store.commit('ugc/tempData/SET_RECIPE', this.recipe_v2);
      this.$store.commit('personalization/CHANGE_VIEW', 'personalization-main-view');
      this.$store.commit('personalization/RESET_DATA');
      this.$eventBus.$emit('recalculate-customizer-screen-size');
      this.$eventBus.$emit('set-component-personalization-modal', 'personalizationMainView');
      this.$store.commit('personalization/SET_CHANGE_STYLE_FLOW', false);
    },

    /**
     * Get Color By Name
     * @param colorName
     */
    getColorByName(colorName) {
      let color = null;
      const colors = this.$store.getters['personalization/getItemsData'][0].font_colors;
      for(let i in colors) {
        if (colors[i].name === colorName) {
          color = colors[i];
          break;
        }
      }
      if (color === null) {
        for(let i in colors) {
          if (colors[i].default_color === true) {
            color = colors[i];
            break;
          }
        }
      }

      return color;
    },
  },
  created() {
    this.$store.commit('ugc/tempData/SET_RECIPE', this.recipe_v2);
    this.$eventBus.$on('set-component-personalization-modal', this.setComponentName);
    this.$eventBus.$on('remove-components', this.applyComponentPersonalization);
    this.$eventBus.$on('close-embroidery-modal', this.closeModal);
    this.$eventBus.$on('apply-personalization-from-swatch', this.applyPersonalizationFromSwatch);
  },
  destroyed() {
    this.$eventBus.$off('set-component-personalization-modal', this.setComponentName);
    this.$eventBus.$off('remove-components', this.applyComponentPersonalization);
    this.$eventBus.$off('close-embroidery-modal', this.closeModal);
    this.$eventBus.$off('apply-personalization-from-swatch', this.applyPersonalizationFromSwatch);
  },
};
